export const getInitials = (name: string, depth = 2) => {
	return name
		.split(" ")
		.slice(0, depth)
		.map((n) => n[0])
		.join("");
};
